export default {
  width: 11,
  height: 12,
  stroke: true,
  svg: `
<rect x="1.7832" y="11.3496" width="2.52059" height="12.603" transform="rotate(-135 1.7832 11.3496)"/>
<rect y="2.43555" width="2.5206" height="12.603" transform="rotate(-45 0 2.43555)"/>
`
}
